export default "__VITE_ASSET__CU9cWXA6__"